import React, { useState } from 'react';
import { FormInputRadio } from '../../../common/formInputsV2/FormInputRadio';
import { FormInputText } from '../../../common/formInputsV2/FormInputText';
import { FormInputSelect } from '../../../common/formInputsV2/FormInputSelect';
import { FormInputAddressComplete } from '../../../common/formInputsV2/FormInputAddressComplete';
import { FormInputAddressCompleteManual } from '../../../common/formInputsV2/FormInputAddressCompleteManual';
import { genders } from '../../../common/constants';
import { DOCUMENT_HINT } from '../documentPrefill';
// import { searchCauzioniCustomers } from '../../../services/axios-client/axeCauzioni';

/* "Cerca in anagrafica" is parked, not deleted — the whole feature is commented out together
   (constants, state, debounce effect, selectResult, markup) rather than just its markup, because
   leaving the parts behind would only produce unused-variable lint errors. The endpoint it calls
   (searchCauzioniCustomers) is untouched and still live. */
// const SEARCH_DEBOUNCE_MS = 400;
// const SEARCH_MIN_CHARS = 3;

// Cleared on every gender change so a Persona Giuridica identity match found before the
// switch never leaks its business fields onto a Persona Fisica contraente, or vice versa.
// This covers identity only — the address/contact fields a search result also prefills
// are handled separately below, because clearing them unconditionally would be wrong.
const IDENTITY_RESET_FIELDS = {
  business_name: '',
  vat_number: '',
  company_type: '',
  name: '',
  surname: '',
  fiscal_code: '',
  active_customer_id: null,
};

// selectResult (below) prefills these from the chosen active_customer alongside the
// identity fields. If the broker switches gender afterwards, the identity no longer
// belongs to that customer, so its address/contacts must go too — but only when
// active_customer_id is still set, i.e. only when the values demonstrably came from a
// search result. If the broker typed these by hand, active_customer_id was never set and
// this reset must not run, or every gender toggle would wipe manually entered data.
const PREFILL_RESET_FIELDS = {
  address: '',
  house_number: '',
  postal_code: '',
  residence_commune_code: '',
  residence_province_code: '',
  email: '',
  phone: '',
};

function StepContraente({
  register, errors, watch, setValue, isValid, municipalities = [], companyTypes = [], formDataError = false,
  prefilled = new Set(),
}) {
  const gender = watch('gender');
  // const [searchTerm, setSearchTerm] = useState('');
  // const [results, setResults] = useState([]);
  // const [searching, setSearching] = useState(false);
  // const [searchError, setSearchError] = useState(false);
  const [showManualAddress, setShowManualAddress] = useState(false);

  // The address autocomplete resolves the comune itself, so it writes the same code columns
  // the manual selector does. It reads and writes a flat object rather than the form API.
  const addressFormData = {
    address: watch('address'),
    house_number: watch('house_number'),
    postal_code: watch('postal_code'),
    residence_commune_code: watch('residence_commune_code'),
    residence_province_code: watch('residence_province_code'),
  };

  const updateFormData = (data) => {
    Object.entries(data).forEach(([field, value]) => {
      setValue(field, value, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
    });
  };

  // useEffect(() => {
  //   const term = searchTerm.trim();
  //   if (term.length < SEARCH_MIN_CHARS) {
  //     setResults([]);
  //     setSearching(false);
  //     setSearchError(false);
  //     return undefined;
  //   }
  //
  //   let cancelled = false;
  //   setSearching(true);
  //   setSearchError(false);
  //
  //   const timer = setTimeout(() => {
  //     searchCauzioniCustomers(gender, term)
  //       .then((res) => {
  //         if (!cancelled) setResults(res.customers);
  //       })
  //       .catch(() => {
  //         if (!cancelled) setSearchError(true);
  //       })
  //       .finally(() => {
  //         if (!cancelled) setSearching(false);
  //       });
  //   }, SEARCH_DEBOUNCE_MS);
  //
  //   return () => {
  //     cancelled = true;
  //     clearTimeout(timer);
  //   };
  // }, [searchTerm, gender]);

  const genderRegistration = register('gender');

  const onGenderChange = (e) => {
    genderRegistration.onChange(e);
    // Read before IDENTITY_RESET_FIELDS nulls it below: only a value that was set by
    // selectResult means the address/contact fields also came from that customer.
    const hadActiveCustomer = Boolean(watch('active_customer_id'));
    const fieldsToReset = hadActiveCustomer
      ? { ...IDENTITY_RESET_FIELDS, ...PREFILL_RESET_FIELDS }
      : IDENTITY_RESET_FIELDS;
    Object.entries(fieldsToReset).forEach(([field, value]) => {
      setValue(field, value, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
    });
    // setSearchTerm('');
    // setResults([]);
  };

  // const selectResult = (customer) => {
  //   setValue('active_customer_id', customer.id, { shouldDirty: true, shouldTouch: true });
  //   setValue('business_name', customer.business_name ?? '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  //   setValue('vat_number', customer.vat_number ?? '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  //   setValue('company_type', customer.company_type ?? '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  //   setValue('fiscal_code', customer.fiscal_code ?? '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  //   setValue('name', customer.name ?? '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  //   setValue('surname', customer.surname ?? '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  //   setValue('address', customer.address ?? '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  //   setValue('house_number', customer.house_number ?? '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  //   setValue('postal_code', customer.postal_code ?? '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  //   // active_customers.residence_city_code and customers.residence_commune_code hold the same
  //   // cadastral code under two different column names — map on the way into the form.
  //   setValue('residence_commune_code', customer.residence_city_code ?? '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  //   setValue('residence_province_code', customer.residence_province_code ?? '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  //   // Prefill only: email/phone come along for convenience, PEC does not exist on this
  //   // endpoint's response and is left for the broker to type in the Contatti step.
  //   setValue('email', customer.email ?? '', { shouldDirty: true, shouldTouch: true });
  //   setValue('phone', customer.phone ?? '', { shouldDirty: true, shouldTouch: true });
  //
  //   setResults([]);
  //   setSearchTerm(customer.business_name || `${customer.name ?? ''} ${customer.surname ?? ''}`.trim());
  // };

  return (
    <div data-testid="cauzioni-step-contraente">
      <div className="cauzioni-gender-group" data-testid="cauzioni-gender">
        <FormInputRadio
          label="Il contraente è"
          name="gender"
          options={genders}
          registration={{ ...genderRegistration, onChange: onGenderChange }}
          error={errors.gender?.message}
        />
      </div>

      {/* <div className="cauzioni-info-card">
        <div className="cauzioni-card-body">
          <label className="fw-bold d-block mb-2" htmlFor="cauzioni-customer-search-input">
            Cerca in anagrafica
          </label>
          <input
            id="cauzioni-customer-search-input"
            type="search"
            className="form-control"
            placeholder="Cerca per nome, ragione sociale, P.IVA o codice fiscale..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            data-testid="cauzioni-customer-search"
          />
          {searching && <p className="cauzioni-count mb-0 mt-2">Ricerca in corso...</p>}
          {!searching && searchError && (
            <p className="cauzioni-count cauzioni-error mb-0 mt-2">Ricerca non riuscita. Riprova.</p>
          )}
          {!searching && !searchError && results.length > 0 && (
            <ul className="list-unstyled mt-2 mb-0">
              {results.map((customer) => (
                <li key={customer.id}>
                  <button
                    type="button"
                    className="btn btn-outline-success btn-sm w-100 text-start mb-2"
                    onClick={() => selectResult(customer)}
                    data-testid="cauzioni-customer-result"
                  >
                    <strong>
                      {customer.business_name || `${customer.name ?? ''} ${customer.surname ?? ''}`.trim()}
                    </strong>
                    {' — '}
                    {customer.vat_number || customer.fiscal_code}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div> */}

      {gender === 'G' ? (
        <>
          <FormInputText
            label="Ragione sociale"
            registration={register('business_name')}
            error={errors.business_name?.message}
            valid={isValid('business_name')}
            hint={prefilled.has('business_name') ? DOCUMENT_HINT : undefined}
          />
          <FormInputText
            label="Partita IVA"
            registration={register('vat_number')}
            error={errors.vat_number?.message}
            valid={isValid('vat_number')}
            hint={prefilled.has('vat_number') ? DOCUMENT_HINT : undefined}
          />
          <FormInputSelect
            label="Tipologia azienda"
            registration={register('company_type')}
            error={errors.company_type?.message}
            valid={isValid('company_type')}
            hint={prefilled.has('company_type') ? DOCUMENT_HINT : undefined}
            placeholder="-Seleziona-"
            options={companyTypes}
          />
        </>
      ) : (
        <>
          <FormInputText
            label="Nome"
            registration={register('name')}
            error={errors.name?.message}
            valid={isValid('name')}
            hint={prefilled.has('name') ? DOCUMENT_HINT : undefined}
          />
          <FormInputText
            label="Cognome"
            registration={register('surname')}
            error={errors.surname?.message}
            valid={isValid('surname')}
            hint={prefilled.has('surname') ? DOCUMENT_HINT : undefined}
          />
          <FormInputText
            label="Codice Fiscale"
            registration={register('fiscal_code')}
            error={errors.fiscal_code?.message}
            valid={isValid('fiscal_code')}
            hint={prefilled.has('fiscal_code') ? DOCUMENT_HINT : undefined}
          />
        </>
      )}

      {formDataError && (
        <p className="cauzioni-count cauzioni-error mb-2">
          Impossibile caricare l&apos;elenco comuni. Riprova più tardi.
        </p>
      )}
      {showManualAddress ? (
        <FormInputAddressCompleteManual
          municipalities={municipalities}
          formData={addressFormData}
          isValid={isValid}
          errors={errors}
          register={register}
          updateFormData={updateFormData}
        />
      ) : (
        <FormInputAddressComplete
          municipalities={municipalities}
          formData={addressFormData}
          isValid={isValid}
          errors={errors}
          register={register}
          updateFormData={updateFormData}
          addressId="autocomplete-address-cauzioni-contraente"
          setShow={setShowManualAddress}
          showManualAdress={showManualAddress}
        />
      )}
    </div>
  );
}

export default StepContraente;
